import { BTIconNotifications } from "commonComponents/btWrappers/BTIcon";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";

interface IMenuItemNotifyOwnersProps {
    fileId: number;
    onClick: () => Promise<void>;
}

const MenuItemNotifyOwners = ({ fileId, onClick, ...antProps }: IMenuItemNotifyOwnersProps) => {
    return (
        <BTMenu.Item
            {...antProps}
            key={`notifyOwners-menuitem-${fileId}`}
            testid={`notifyOwners-menuitem-${fileId}`}
            onClick={onClick}
        >
            <BTIconNotifications isOnWhite /> Notify clients
        </BTMenu.Item>
    );
};

export default MenuItemNotifyOwners;
